
import { createSelector } from 'reselect';
import _ from 'lodash';
import moment from 'moment';
import dayjs from 'dayjs';

import { Modals, RequestState, Hosts, DEFAULT_ENV } from 'constants/constants';
import { selectLocation, selectQueryParam, } from 'store/selectors';
import { createAction } from 'utils/store';

import UIState, { selectModals, selectToast } from 'store/UIState';
import RouteState from 'store/RouteState';
import User, { SET_LOGIN, LOGIN_USER, START_SESSION, LOGOUT_USER, AUTH_USER, selectUserById } from 'store/models/User';

// ======================
// HELPERS
// ====================== 


const closeOverlays = {
  showMenu: false,
};
const MESSAGE_TIMER = 3500;

const SPEC = {
  showMenu: false,
  message: {
    text: null,
    ts: null,
    show: false,
    type: 'success'
  },
  logs: [],
  token: null,
  currentUserId: _.get(window.hs_user, 'userId'),
  config: window.hs_config,
  authUser: window.hs_user ?? {},
  appDateRange: {
    range: '30days',
    dates: {
      from: dayjs().subtract(30, 'days').startOf('day').toDate(),
      to: dayjs().toDate(),
    }
  },
  reportDateRange: null,
};


// ======================
// ACTIONS
// ====================== 

export const SET_TOKEN = 'SET_TOKEN';

export const TOGGLE_MENU = 'TOGGLE_MENU';
export const SET_ENVIRONMENT = 'SET_ENVIRONMENT';

export const SHOW_ERROR = 'SHOW_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const CLEAR_SUCCESS = 'CLEAR_SUCCESS';

export const SET_APP_DATE_RANGE = 'SET_APP_DATE_RANGE';
export const SET_REPORT_DATE_RANGE = 'SET_REPORT_DATE_RANGE';



// ======================
// SELECTORS
// ====================== 
export const selectCurrentUserId = state => state.app.authUser?.userId;
export const selectCurrentAccountId = state => state.app.authUser?.accountId;
export const selectCurrentUser = state => selectUserById(state, selectCurrentUserId(state));

export const selectErrorMessage = state => state.app.errorMessage;
export const selectApiToken = state => state.app.token;

export const selectAppDateRange = state => state.app.appDateRange;
export const selectReportDateRange = state => state.app.reportDateRange ?? state.app.appDateRange;
export const selectDates = state => state.app.appDateRange.dates;

export const selectConfig = state => state.app.config;
export const selectConfigItem = (state, keyPath) => _.get(state.app.config, keyPath);
export const selectSpoof = (state) => _.get(state.app, 'authUser.s');
export const selectNodeEnv = state => state.app.config.node_env;

export const selectApiHost = state => window.location.origin; //state.app.config.hosts.API;
export const selectHost = (state, type) => state.app.config.hosts[type];

export const selectTwitchConfig = state => state.app.config.twitch;
export const selectAuthConfig = state => state.app.config.auth;





// ======================
// MODEL
// ====================== 

const State = {
  actions: {
    fetchAppData: () => {
    
    },

    toggleMenu() {
      return createAction({
        type: TOGGLE_MENU,
      });
    },

    show(fn, message) {
      return (...rest) => {
        return (dispatch, getState) => {
          return dispatch(fn(...rest))
            .then(json => dispatch(this.showSuccess(message)))
            .catch(err => dispatch(this.showError(err)));
        }
      }
    },

    showSuccess(message) {
      return (dispatch, getState) => {
        let ts = new Date().getTime();
        dispatch(createAction({
          type: SHOW_SUCCESS,
          ts,
          message: message && message.length  ? `SUCCESS: ${message}` : `SUCCESS`,
        }));
        let t = setTimeout(() => dispatch(this.clearSuccess(ts)), MESSAGE_TIMER)
        return Promise.resolve();
      }
    },

    showError(err) {
      return (dispatch, getState) => {

        let ts = new Date().getTime();
        let message = err && (err.message ? err.message : err.toString());

        dispatch(createAction({
          type: SHOW_ERROR,
          ts,
          message: message && message.length ? `ERROR: ${message}` : `ERROR`,
        }));
        let t = setTimeout(() => dispatch(this.clearError(ts)), MESSAGE_TIMER)
        return Promise.resolve();
      }
    },

    clearSuccess(key) {
      return createAction({
        type: CLEAR_SUCCESS,
        message,
      });
    },

    clearError(key) {
      return createAction({
        type: CLEAR_ERROR,
        message,
      });
    },

    setAppDateRange(range, dates) {
      return createAction({
        type: SET_APP_DATE_RANGE,
        appDateRange: { range, dates },
      });
    },

    setReportDateRange(range, dates) {
      return createAction({
        type: SET_REPORT_DATE_RANGE,
        reportDateRange: { range, dates },
      });
    },

    
  },

  reducer(state = SPEC, action) {
    let s = state;
    let { result, body, json } = action;

    switch (action.type) {

      case SET_TOKEN:
        return {...state, token: action.token};
      case TOGGLE_MENU:
        return _.assign({}, state, { showMenu: !state.showMenu });

      case SHOW_ERROR:
      case SHOW_SUCCESS:
        return _.assign({}, state, { message: {
          text: action.message,
          type: action.type === SHOW_SUCCESS ? 'success' : 'error',
          show: true,
        } });
      case CLEAR_ERROR: 
      case CLEAR_SUCCESS:
        return {...state, message: _.defaults({ show: false }, state.message) };

      case SET_LOGIN:
        if(action.userId)
          return {...state, 
            authUser: { ...state.authUser,
              userId: action.userId,
              accountId: action.accountId,
            } 
          };
        break;

      case LOGOUT_USER:
        return {...state, authUser: null };
      
      case SET_APP_DATE_RANGE:
        return { ...state, appDateRange: action.appDateRange };
      
      case SET_REPORT_DATE_RANGE:
        return { ...state, reportDateRange: action.reportDateRange };
    }
    return state;
  },

}

_.bindAll(State.actions, _.functions(State.actions));
export default State;